import {
  Box,
  Heading,
  HStack,
  IconButton,
  ListItem,
  SimpleGrid,
  Stack,
  UnorderedList,
} from '@chakra-ui/react';
// import {
//   Facebook,
//   Instagram,
//   MailOutlined,
//   Phone,
//   Pinterest,
//   Room,
//   Twitter,
// } from "@material-ui/icons";
import Logo from '../Logo';
import WrapContent from './WrapContent';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaPhoneAlt,
  FaPinterest,
  FaLocationArrow,
  FaEnvelope,
} from 'react-icons/fa';

// const ContactItem = styled.div`
//   margin-bottom: 20px;
//   display: flex;
//   align-items: center;
// `;

const Footer = () => {
  return (
    <Box bg="teal" overflow="hidden">
      <WrapContent>
        <SimpleGrid columns={[1, 1, 1, 3]}>
          <Stack py="40px">
            <Logo />
            <Box py="5">
              DigitalMart is the best marketplace were you can get all your
              gadgets at the comfort of your home with your crypto, for Now we
              support Tron token
            </Box>
            <HStack spacing="5">
              <IconButton
                variant="flushed"
                fontSize="30px"
                icon={<FaFacebook />}
              />
              <IconButton
                variant="flushed"
                fontSize="30px"
                // color="#E4405F"
                icon={<FaInstagram />}
              />
              <IconButton
                variant="flushed"
                fontSize="30px"
                // color="#55ACEE"
                icon={<FaTwitter />}
              />
              <IconButton
                variant="flushed"
                fontSize="30px"
                // color="#E60023"
                icon={<FaPinterest />}
              />
            </HStack>
          </Stack>
          <Box flex="1" p="20px">
            <Heading fontSize={'2opx'} pb="5" as="h3">
              useful Links
            </Heading>
            <SimpleGrid columns={[1, 2, 2, 2]} w="full">
              <UnorderedList w="full" listStyleType={'none'} ml="-1">
                <ListItem mb="20px" w="full">
                  Home
                </ListItem>
                <ListItem mb="20px" w="full">
                  Cart
                </ListItem>
                <ListItem mb="20px" w="full">
                  Categoties
                </ListItem>
                <ListItem mb="20px" w="full">
                  Accessories
                </ListItem>
              </UnorderedList>
              <UnorderedList w="full" listStyleType={'none'} ml="-1">
                <ListItem mb="20px" w="full">
                  My Account
                </ListItem>
                <ListItem mb="20px" w="full">
                  Order Tracking
                </ListItem>
                <ListItem mb="20px" w="full">
                  Wishlist
                </ListItem>
                <ListItem mb="20px" w="full">
                  Terms
                </ListItem>
              </UnorderedList>
            </SimpleGrid>
          </Box>
          <Stack p="20px">
            <Heading fontSize={'2opx'} pb="5" as="h3">
              Contact
            </Heading>

            <HStack spacing="5">
              <Box>
                <FaLocationArrow />
              </Box>
              <p>25, Rumuola Port Harcourt, Rivers, Nigeria.</p>
            </HStack>
            <HStack spacing="5">
              <Box>
                <FaPhoneAlt />
              </Box>{' '}
              <p>+234 816 540 7995</p>
            </HStack>

            <HStack spacing="5">
              <Box>
                <FaEnvelope />
              </Box>
              <p>Contact@digitalmart.com</p>
            </HStack>
          </Stack>
        </SimpleGrid>
      </WrapContent>
    </Box>
  );
};

export default Footer;
